import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { services } from '../data/services';
import { Reveal } from './Reveal';
import { Button } from './Button';
export function ServicesSection() {
  return <section className="bg-mist py-24 lg:py-32" data-id="element-279" data-mp="2gcfvfj3c70nm">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-280" data-mp="2l8n43jn4aq99">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-281" data-mp="2lb9a3eud0xpd">
          <Reveal className="lg:col-span-6" data-id="element-282" data-mp="26jqnuzawq6xk">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-283" data-mp="2bb8n9ixa7zgf" />
            <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-284" data-mp="2bdczqp98y6sb">
              Recruitment services built around your hiring needs.
            </h2>
          </Reveal>
          <Reveal delay={0.05} className="lg:col-span-5 lg:col-start-8" data-id="element-285" data-mp="22gubhqbyn722">
            <p className="text-lg leading-relaxed text-ink/75" data-id="element-286" data-mp="1nm7m8gqs3ql6">
              Finding the right professional takes more than reviewing CVs. We work from a clear
              understanding of the role, search the relevant talent market, and engage candidates
              directly on your behalf.
            </p>
          </Reveal>
        </div>

        <ul className="mt-16 grid gap-6 md:grid-cols-2" data-id="element-287" data-mp="2ynzh8e2ul84q">
          {services.map(({
          title,
          description,
          icon: Icon
        }, i) => <li key={title} data-id="element-288" data-mp="2um4b8w9z26km" data-mpi={i}>
              <Reveal delay={i * 0.05} className="flex h-full flex-col border border-gold/30 bg-white p-8 sm:flex-row sm:gap-8 lg:p-10" data-id="element-289" data-mp="2un5qlcy0tf85">
                <Icon size={32} strokeWidth={1.1} className="shrink-0 text-navy" aria-hidden="true" data-id="element-290" data-mp="21z02qhbo7a43" />
                <div className="mt-8 flex flex-1 flex-col sm:mt-0" data-id="element-291" data-mp="2fpwt01i4jf7z">
                  <h3 className="font-serif text-[28px] font-medium leading-tight text-navy" data-id="element-292" data-mp="2axvesa1ebefb">{title}</h3>
                  <p className="mt-3 leading-relaxed text-ink/70" data-id="element-293" data-mp="1n80yfihvb7qb">{description}</p>
                  <Link to="/employers#enquiry" aria-label={`Discuss ${title} for a role`} className="group mt-auto inline-flex items-center gap-2 self-start pt-8 text-sm font-semibold text-navy focus-visible:outline-none focus-visible:underline focus-visible:decoration-gold focus-visible:underline-offset-4" data-id="element-294" data-mp="1j7h5ys88osai">
                    <span className="border-b border-gold pb-0.5" data-id="element-295" data-mp="v7q4wn0j77r">Discuss a Role</span>
                    <ArrowRightIcon size={16} strokeWidth={1.5} className="transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-296" data-mp="xbutgsqka93" />
                  </Link>
                </div>
              </Reveal>
            </li>)}
        </ul>

        <div className="mt-12 flex justify-center" data-id="element-297" data-mp="3e8aredtsg66b">
          <Button to="/services" variant="outline" data-id="element-298" data-mp="oluytk4r60vd">
            View All Services
          </Button>
        </div>
      </div>
    </section>;
}